"use client";

import { c as _c } from "react/compiler-runtime";
import { readFragment } from "@opensea/graphql";
import { usePersona } from "@opensea/navigation";
import { isAddressEqual } from "@opensea/utils";
import { useCancelOrderFlow } from "@opensea/wallet";
import { useAddress } from "@/hooks/wallet";
import { useCancelOrdersFragment } from "./use-cancel-orders.fragment";
export const useCancelOrders = orderKeys => {
  const $ = _c(5);
  const address = useAddress();
  const orders = orderKeys.map(_temp);
  const {
    persona
  } = usePersona();
  const mode = persona === "advanced" ? "minimized" : "full";
  let t0;
  if ($[0] !== mode) {
    t0 = {
      mode
    };
    $[0] = mode;
    $[1] = t0;
  } else {
    t0 = $[1];
  }
  const {
    cancelOrders
  } = useCancelOrderFlow(t0);
  const handleCancelOrders = function handleCancelOrders() {
    cancelOrders(orders.map(_temp2));
  };
  const canCancelOrders = orders.every(order_1 => order_1.marketplace?.identifier === "opensea" && isAddressEqual(order_1.maker.address, address)) && orders.length > 0;
  let t1;
  if ($[2] !== canCancelOrders || $[3] !== handleCancelOrders) {
    t1 = {
      cancelOrders: handleCancelOrders,
      canCancelOrders
    };
    $[2] = canCancelOrders;
    $[3] = handleCancelOrders;
    $[4] = t1;
  } else {
    t1 = $[4];
  }
  return t1;
};
function _temp(order) {
  return readFragment(useCancelOrdersFragment, order);
}
function _temp2(order_0) {
  return order_0.id;
}